import { render, staticRenderFns } from "./BarComparisonChart.vue?vue&type=template&id=6c57f54b"
import script from "./BarComparisonChart.vue?vue&type=script&lang=js"
export * from "./BarComparisonChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports